import { createContext } from "react";

const AIPopupContext = createContext({
	threads: [],
	currentThread: null,
	setCurrentThread: () => {},
});

export default AIPopupContext;
